import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberService} from "../../service/member/member.service";
import {PageInvoiceHistory} from "../../service/member/member";
import * as moment from "moment";
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bill-board',
  templateUrl: './bill-board.component.html',
  styleUrls: ['./bill-board.component.scss'],
  providers: [MemberService]
})
export class BillBoardComponent {
  history: PageInvoiceHistory = new PageInvoiceHistory();

  page: number;
  startTime: string;
  endTime: string;

  constructor(private memberService: MemberService,
              private router: Router,
              private route: ActivatedRoute,)
  {
    this.route.queryParams.subscribe(
      params => {
        this.page      = params['page']       ? +params['page']     : 1;
        this.startTime = params['startTime']  ? params['startTime'] : moment().startOf('month').format('YYYY-MM-DD');
        this.endTime   = params['endTime']    ? params['endTime']   : moment().endOf('month').format('YYYY-MM-DD');
        this.active    = params['startTime'] && params['endTime'] ?
          moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month')+1+'' : '1';

        this.getHistory();
      }
    );
  }

  setEndTime(endTime: string) {
    this.endTime = moment(endTime, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
  }

  getHistory() {
    this.memberService.getInvoiceHistory(this.page, this.startTime, this.endTime).subscribe(
      res => this.history = {
        ...res,
        items: res.items.map(o => 
        {
          return { ...o, 
            sls_mm: `${moment(o.sls_mm, 'YYYYMM').format('M')} 월`,
            sls_de: moment(o.sls_de, 'YYYYMMDD').format('YYYY-MM-DD'),
            amt_msh_sum: `${o.amt_msh_sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 원`,
          }
        })
      }
    )
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(
      `${url}?` +
      (this.page ? `page=${this.page}` : '') +
      (this.startTime ? `&startTime=${this.startTime}` : '') +
      (this.endTime ? `&endTime=${this.endTime}` : '')
    );
  }

  onSearch() {
    this.active = moment(this.endTime, 'YYYY-MM-DD').diff(moment(this.startTime, 'YYYY-MM-DD'), 'month')+'';
    this.reload();
  }

  active: string;
  onActive(active: string) {
    this.active = active;

    if(active === '1') {
      this.startTime = moment().startOf('month').format('YYYY-MM-DD');
      this.endTime   = moment().endOf('month').format('YYYY-MM-DD');
    }
    else if(active === '2') {
      this.startTime = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      this.endTime   = moment().endOf('month').format('YYYY-MM-DD');
    }
    else if(active === '6') {
      this.startTime = moment().subtract(5, 'month').startOf('month').format('YYYY-MM-DD');
      this.endTime   = moment().endOf('month').format('YYYY-MM-DD');
    }

    this.reload();
  }

  onPageChanged(event: any) {
    if (event.page == this.page) return;

    this.page = event.page;
    this.reload();
  }

  downloadInvoice(item: any) {
    this.memberService.getInvoiceFile(item.file.seq, item.file.original_nm).subscribe(res => {
      let fileBlob = res.blob();
      let blob = new Blob([fileBlob])
        
      let filename = `invoice_${item.sls_de}.${item.file.extension}`;
      saveAs(blob, filename);
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/member/bill-board/bill-board.component.ts